import parser from './parser';

const name = 'radio';

export default {parser, name};